import { useAppSelector } from "../redux"
import { useSelectedVariant } from "./useSelectedVariant"

export const useCurrentPrice = () => {
  const selectedVariant = useSelectedVariant()
  const bundleData = useAppSelector(state => state.product.design_detail.data.bundle_data || [])
  const bundle = useAppSelector(state => state.product.design_detail.data.bundle)
  
  if (bundle) {
    return bundleData.reduce((t, product) => {
      const selectedVariant = product.variants.find(v => !!v.selected)
      return {
        price: t.price + (selectedVariant?.price || 0),
        compare_at_price: t.price + (selectedVariant?.compare_at_price || 0),
      }
    }, {
      price: 0,
      compare_at_price: 0
    })
  }
  
  return {
    price: selectedVariant?.retail_price || 0,
    compare_at_price: selectedVariant?.compare_at_price || 0
  }
}